import React from 'react';
import { getLegalDocUrl } from '../utils/api';

/** Purpose: Builds content map for legal pages. Inputs: none. Output: legal notice content map. */
function getLegalContent() {
  return {
    legal: {
      heading: 'Core Policies',
      links: [
        { label: 'Privacy Policy', href: getLegalDocUrl('privacy') },
        { label: 'Terms of Use', href: getLegalDocUrl('terms') },
        { label: 'HIPAA Notice', href: getLegalDocUrl('hipaa-notice') }
      ]
    },
    privacy: {
      heading: 'Privacy Policy',
      links: [
        { label: 'Open Privacy Policy', href: getLegalDocUrl('privacy') },
        { label: 'Back to Legal Notices', href: '/legal' }
      ]
    },
    terms: {
      heading: 'Terms of Use',
      links: [
        { label: 'Open Terms of Use', href: getLegalDocUrl('terms') },
        { label: 'Back to Legal Notices', href: '/legal' }
      ]
    },
    hipaa: {
      heading: 'HIPAA Notice',
      links: [
        { label: 'Open HIPAA Notice', href: getLegalDocUrl('hipaa-notice') },
        { label: 'Back to Legal Notices', href: '/legal' }
      ]
    }
  };
}

/** Purpose: Renders a legal notice page. Inputs: { notice = 'legal' }. Output: React render output (JSX). */
export default function LegalNotice({ notice = 'legal' }) {
  const content = getLegalContent();
  const key = Object.prototype.hasOwnProperty.call(content, notice) ? notice : 'legal';
  const page = content[key];

  return (
    <div className="min-h-screen bg-[#f3f4f6] text-slate-900">
      <main className="max-w-4xl px-6 sm:px-10 py-12 sm:py-16">
        <h1 className="text-5xl sm:text-7xl font-bold tracking-tight text-black">MedCaddy</h1>
        <h2 className="text-5xl sm:text-7xl font-bold tracking-tight text-slate-400 mt-2">Legal Notices</h2>

        <section className="mt-20">
          <h3 className="text-4xl sm:text-5xl font-semibold tracking-tight text-black">{page.heading}</h3>
          <ul className="mt-8 space-y-4 sm:space-y-5">
            {page.links.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  className="text-2xl sm:text-4xl font-medium text-slate-500 hover:text-slate-700 transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </section>

        <div className="mt-16">
          <a href="/" className="text-lg sm:text-xl text-slate-500 hover:text-slate-700">
            Back to app
          </a>
        </div>
      </main>
    </div>
  );
}
